const MILESTONE_LABELS = {
  BOOKING: 'Booking Confirmed',
  DEPARTURE: 'Departed Origin',
  ARRIVAL: 'Arrived Destination',
  CUSTOMS: 'Customs Cleared',
  DELIVERY: 'Delivered'
};

const STATUS_ICONS = {
  COMPLETED: '\u2713',
  DELAYED: '!',
  PENDING: '\u25CB',
  SKIPPED: '\u2014'
};

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
};

const Timeline = ({ milestones = [] }) => {
  if (milestones.length === 0) {
    return (
      <div className="timeline-empty">
        <p>No milestones yet. Milestones will appear when shipment is booked.</p>
      </div>
    );
  }

  // Find current active milestone (first non-completed)
  const currentIndex = milestones.findIndex(
    m => m.status === 'PENDING' || m.status === 'DELAYED'
  );

  return (
    <div className="timeline">
      {milestones.map((milestone, index) => {
        const isCurrent = index === currentIndex;
        const statusClass = milestone.status.toLowerCase();

        return (
          <div
            key={milestone.id}
            className={`timeline-item ${statusClass} ${isCurrent ? 'current' : ''}`}
          >
            <div className="timeline-marker">
              <span className={`timeline-dot ${statusClass}`}>
                {STATUS_ICONS[milestone.status] || '\u25CB'}
              </span>
              {index < milestones.length - 1 && (
                <div className={`timeline-line ${milestone.status === 'COMPLETED' ? 'completed' : ''}`} />
              )}
            </div>
            <div className="timeline-content">
              <div className="timeline-header">
                <h4>{MILESTONE_LABELS[milestone.milestoneType] || milestone.milestoneType}</h4>
                {milestone.status === 'DELAYED' && milestone.delayHours > 0 && (
                  <span className="delay-badge">+{milestone.delayHours}h delay</span>
                )}
              </div>
              <div className="timeline-dates">
                {milestone.expectedDate && (
                  <span className="expected-date">
                    Expected: {formatDate(milestone.expectedDate)}
                  </span>
                )}
                {milestone.actualDate && (
                  <span className="actual-date">
                    Actual: {formatDate(milestone.actualDate)}
                  </span>
                )}
              </div>
              {isCurrent && (
                <span className="current-label">In Progress</span>
              )}
              {milestone.notes && (
                <p className="timeline-notes">{milestone.notes}</p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Timeline;
